<template>
  <hic-list-page title="费用结算" :entities="entities" :condition="condition"  @load="queryEntities" :loading="meta.loading">
    <template slot="buttons">
      <el-button type="primary" size="small" icon="el-icon-document-add" @click="selInfo = {};isNew = true;meta.showNew = true;">费用结算</el-button>
    </template>
    <template slot="search">
      <el-date-picker @change="dateChange" style="width: 270px" size="small" v-model="condition.date" type="daterange"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
    </template>

    <el-table-column width="100px" align="center" label="操作">
      <template slot-scope="{ row }">
        <el-button v-if="row.ifExecCancel" title="撤回" type="info" plain size="mini" circle icon="el-icon-bottom" @click="inDetail(row, true)"></el-button>
      </template>
    </el-table-column>
    <el-table-column align="center" width="100px" label="状态" prop="state"> </el-table-column>

    <el-table-column align="center" width="160px" label="流水号" prop="no">
      <template slot-scope="{ row }">
        <!-- <div class="ftcolor-base">{{ row.no }}</div> -->
        <el-button title="" type="text" plain size="mini" @click="inDetail(row)">{{ row.no }}</el-button>
      </template>
    </el-table-column>
    <el-table-column align="center" label="患者姓名" prop="patientName"> </el-table-column>
    <el-table-column align="center" width="160px" label="住院号" prop="ipNo"> </el-table-column>
    <el-table-column align="center" label="年龄" prop="patientAge">
      <!-- <template slot-scope="{ row }">
           <div>{{row.birthday | age}}</div> 
          </template> -->
    </el-table-column>
    <el-table-column align="center" label="收费类别" prop="ipType">
    </el-table-column>
    <el-table-column align="center" label="结算人" prop="createUserName"> </el-table-column>
    <el-table-column align="center" width="160px" label="结算日期" prop="settlementTime"> </el-table-column>

    <!-- <settle :visible.sync="meta.showSettle" from="patient" :ipNo="settingIpNo" :isNew="true"></settle> -->

    <new :visible.sync="meta.showNew" from="settle" :ipNo="ipNo" :isNew="isNew" :settleId="settleId" @close="queryEntities" :isRevoke="isRevoke"></new>
  </hic-list-page>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
let that;
export default {
  components: {
    new: () => import("./new"),
  },
  data() {
    return {
      title: "",
      meta: {
        showDetail: false,
        showlevel: false,
        showType: false,
        showNew: false,
        loading: false,
        remind: false,
      },
      isNew: false,
      settleId: '',
      ipNo: "",
      condition: {
        keyword: "",
        pageSize: 10,
        pageNum: 1,
        sort: "id",
        asc: false,
      },
      entities: {},
      isRevoke:false
    };
  },
  computed: {
    ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
  },
  filters: {
    genderFlter(v) {
      let info = that.dict.Gender.find((item) => {
        return v == item.code;
      });
      return info ? info.name : v;
    },
  },
  created() {
    that = this;
  },
  methods: {
    dateChange(v) {
      this.execTimeSt = utils.fmtDateTime(v[0]);
      this.execTimeEd = utils.fmtDateTime(v[1]);
      this.queryEntities();
    },
    queryEntities() {
      this.meta.loading = true;
      try {
        api.Settlement.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      } catch (err) {
        if (err && err != "cancel") {
          console.log(err);
          this.$message.error(err.message || err);
        }
      }
    },
    restore() {
      // let self = this;
      // self
      //   .$confirm("确定要进行结算还原吗", "取消", { type: "warning", cancelButtonText: "关闭" })
      //   .then(() => {
      //     self.meta.loading = true;
      //     api
      //       .cancel(self.selInfo.床位记录id)
      //       .then((res) => {
      //         self.meta.loading = false;
      //         self.$message.success("取消成功");
      //         self.getBedList();
      //       })
      //       .catch((err) => {
      //         self.meta.loading = false;

      //         self.$message.error(err);
      //       });
      //   })
      //   .catch((e) => { });
    },
    inDetail(row,isRevoke) {
      this.settleId = row.id + '';
      this.ipNo = row.ipNo;
      this.isNew = false;
      this.isRevoke = !!isRevoke
      this.meta.showNew = true;
    },
  },
};
</script>

<style scoped>
.redaK {
  margin-left: 1rem;
  background-color: #909399;
}

.wedge-left {
  margin-left: 5px;
}

.condition-wide {
  width: 17rem;
}

.el-tag--dark {
  border-color: rgba(0, 0, 0, 0);
}

.tofvoer {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
